import {
  Alert,
  AlertColor,
  Autocomplete,
  Box,
  Grid,
  Snackbar,
  TextField,
} from '@mui/material'
import { User, UserProfiles } from 'api/models/User.type'

import SectionHeader from 'components/Common/SectionHeader'
import Form from 'components/RouteWizard/Form'
import { useRef, useState } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'

import { updateClientUserProfile } from 'reducers/clientsReducer'
import * as yup from 'yup'

interface AddUserToProfileProps {
  clientUsers: User[] // Assuming full User objects
  userProfiles: UserProfiles[] // Only id and name of user profiles
  successCallback?: () => void
}

export const AddUserToProfile = (props: AddUserToProfileProps) => {
  const [alertMessage, setAlertMessage] = useState('')
  const [alertType, setAlertType] = useState<AlertColor>()
  const [showAlert, setShowAlert] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const formMethods = useRef<UseFormReturn | null>(null)

  const schema = yup.object().shape({
    user: yup.object().required().label('User'),
    userProfile: yup.object().required().label('User Profile'),
  })

  console.log('AddUserToProfile: props', props)

  const onSubmit = async (data: any) => {
    setIsLoading(true)
    console.log('Add Client User Profile: onSubmit', data)
    try {
      const selectedUserProfile = props.userProfiles.find(
        (profile) => profile.id === data.userProfile.id,
      )

      if (selectedUserProfile) {
        console.log(
          'Add Client User Profile: selectedUserProfile',
          selectedUserProfile,
        )
        selectedUserProfile.users = [
          ...(selectedUserProfile.users?.map((user) => user.userId) || []),
          data.user.id,
        ]
      }

      console.log(
        'Add Client User Profile: selectedUserProfile',
        selectedUserProfile,
      )

      await updateClientUserProfile({
        userProfile: selectedUserProfile,
        clientId: data.user.clientId,
      })

      setShowAlert(true)
      setAlertMessage('Profile Updated')
      setAlertType('success')
      setIsLoading(false)
      props.successCallback?.()
    } catch (error) {
      setShowAlert(true)
      setAlertMessage(`No updates made: ${error.message}`)
      setAlertType('error')
      setIsLoading(false)
    }
  }

  const defaultValues = {}

  const handleAlertClose = () => setShowAlert(false)

  return (
    <>
      <Box
        component="div"
        sx={{
          width: '100%',
          fontSize: '14px',
          backgroundColor: '#F8F8F8',
          color: '#8E8E8E',
          display: 'flex',
          flexShrink: 1,
          flexDirection: 'column',
          alignItems: 'center',
          paddingBottom: '20px',
        }}
      >
        <Grid
          container
          style={{
            width: '90%',
            display: 'block',
            textAlign: 'left',
            paddingTop: '20px',
          }}
        >
          <Form
            isLoading={isLoading}
            schema={schema}
            defaultValues={{
              ...defaultValues,
            }}
            ref={formMethods}
            onSubmit={onSubmit}
            submitText="Update"
          >
            <SectionHeader title="Add User to Profile" />
            <Controller
              name="userProfile"
              control={formMethods.current?.control}
              render={({ field, fieldState: { error } }) => (
                <Autocomplete
                  {...field}
                  options={props.userProfiles}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select User Profile"
                      variant="outlined"
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                  onChange={(_, value) => field.onChange(value)}
                />
              )}
            />
            <Controller
              name="user"
              control={formMethods.current?.control}
              render={({ field, fieldState: { error } }) => (
                <Autocomplete
                  {...field}
                  options={props.clientUsers}
                  getOptionLabel={(option) =>
                    `${option.firstName} ${option.lastName} (${option.email})`
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select User"
                      variant="outlined"
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                  onChange={(_, value) => field.onChange(value)}
                />
              )}
            />
          </Form>
        </Grid>
      </Box>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={handleAlertClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert
          onClose={handleAlertClose}
          severity={alertType}
          sx={{ width: '100%' }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  )
}

export default AddUserToProfile
